module.exports = __webpack_public_path__ + "media/images/brand/lander/right-1ff781fc15f2953e93c48215f26893ed.png";